import { useState } from 'react'
import { Create, useTranslate } from 'react-admin'

import { BackFromEditorButton } from 'components/common/BackFromEditorButton'

import SchoolForm from './SchoolForm'

const SchoolCreate = (props) => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)

    return (
        <>
            <BackFromEditorButton isPristineForm={isPristineForm} backToRouteURL="/school" />
            <Create title={translate(`manager.resources.${props.resource}.create`)} {...props}>
                <SchoolForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                    {...props}
                />
            </Create>
        </>
    )
}

export default SchoolCreate
